import baseTemplate from './pdp-slider.html';
import sliderModal from './pdp-slider-modal.html';

/** @typedef {{ url: string, thumbnail: string?, alt: string }} Slide */

/**
 * generate a main slide html string
 * @param {Object<Slide>} param // normalized slide object
 * @returns {string} // html string representation of a main slide
 */
const mainSlide = ({ thumbnail, alt }) => `
    <div class="pdp-slider__main-item">
        <img
            class="pdp-slider__main-slide"
            src="${thumbnail}"
            alt="${alt}" />
    </div>
`;

/**
 * generate html string for a navigation arrow
 * @param {string} srText // string to render for screen readers 
 * @returns {string} // html string representation of a nav slide
 */
const navArrow = (srText = 'Next') => `
    <button class="pdp-slider__arrow" type="button">
        <span class="sr-only">${srText}</span>
    </button>
`;

/**
 * generate a nav slide html string
 * @param {Object<Slide>} param // normalized slide object
 * @returns {string} // html string representation of a nav slide
 */
const navSlide = ({ alt, isButton, thumbnail, srText }) => {
    const navBtn = content => `
        <button class="pdp-slider__nav-btn" type="button" data-control="nav">
            <span class="sr-only">${srText}</span>
            ${content}
        </button>
    `;

    const image = `
        <img
            class="pdp-slider__nav-slide"
            src="${thumbnail}"
            alt="${alt}" />
    `;

    return `
        <div class="pdp-slider__nav-item">
            ${ isButton ? navBtn(image) : image }
        </div>
    `;
};

export {
    mainSlide,
    navArrow,
    navSlide,
    sliderModal
};

export default baseTemplate;
